import { Button, Form, Input, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { changeTheme } from "@/redux/slices/theme.slice";
import { setActiveDashboard, setIsLogged, setUserDetails } from "@/redux/slices/user.slice";
import { flare } from "@flareapp/js";

export default function Settings() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userDetails } = useSelector((state) => state.user || {});
  const business = userDetails?.business?.[0] || {};

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = `${appConfig.name} - Settings`;
  }, []);

  const logOut = async () => {
    try {
      await api.get(`/user/logout`, {
        withCredentials: true,
      });
      localStorage.setItem("isLoggedIn", "no");
      dispatch(setActiveDashboard(""));
      dispatch(setIsLogged(false));
      dispatch(changeTheme(false));
      dispatch(setUserDetails({}));
      // window.localStorage.clear();
      if (business?.businessUrl) {
        navigate("/" + business?.businessUrl);
      } else {
        navigate("/");
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  };

  const onFinish = async (body) => {
    setIsLoading(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update password?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    })
      .then((result) => {
        if (result.isConfirmed) {
          api
            .put(endpoint.update_user_password, body)
            .then(async () => {
              await Swal.fire({
                title: "Done!",
                text: "Password Updated Successfully",
                icon: "success",
                timer: 2000,
                button: false,
              });
              logOut();
            })
            .catch(function (error) {
              if (error) {
                Swal.fire({
                  title: "Cancelled!",
                  text: "Current password not matched",
                  icon: "error",
                  timer: 2000,
                  button: false,
                });
              }
            })
            .finally(() => setIsLoading(false));
        }
      })
      .finally(() => setIsLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    // eslint-disable-next-line no-console
    console.log("Failed:", errorInfo);
  };

  return (
    <Spin spinning={isLoading}>
      <div className="card p-3 m-md-3">
        <div>
          <label className="az-content-label">Settings</label>
          <span className="d-block py-2">Change Password</span>
        </div>
        <hr className="mt-0" />
        <div className="row">
          <div className="col-md-6">
            <Form layout="vertical" name="users" onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
              <Form.Item
                label="Current Password"
                name="currentPassword"
                rules={[
                  {
                    required: true,
                    message: "Enter Your Current Password",
                  },
                  { min: 6, message: "Password must be minimum 6 characters." },
                ]}
              >
                <Input.Password placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" />
              </Form.Item>
              <Form.Item
                label=" New Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Enter Your Password",
                  },
                  { min: 6, message: "Password must be minimum 6 characters." },
                ]}
              >
                <Input.Password placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" />
              </Form.Item>
              <Form.Item
                label="Retype New Password"
                name="repeatPassword"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Retype New Password",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Both Passwords Are Not Matching"));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" />
              </Form.Item>

              <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
                <Button type="primary" htmlType="submit">
                  Update
                </Button>
                <Button type="primary" className="bg-secondary" onClick={() => navigate(-1)} htmlType="button">
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
          <div className="col-md-6"></div>
        </div>
      </div>
    </Spin>
  );
}
